import React, { useState } from 'react';
import styled from 'styled-components';
import { TABLET_WIDTH } from '~~elements/Const';
import { FirstBaseResource } from '~~apis/resource';
import FirstBaseHeader from './FirstBaseHeader';
import PermissionList from './PermissionList';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  letter-spacing: 1px;
  padding-top: 2rem;

  @media (max-width: ${TABLET_WIDTH}) {
    align-items: center;
  }
`;

const permissionTooltipMapping = {
  ADMIN: '可進行所有操作，至少需有一位管理者',
  EDITOR: '不得修改管理者權限、不得調整訂閱內容',
  VIEWER: '僅提供瀏覽球隊 First Base 系統',
};

const FirstBasePermission = ({ userInfo, firstBases, reload }) => {
  const [teamIndex, setTeamIndex] = useState(0);
  const updatePermission = ({ userUniqid, targetUniqid, authority }) => {
    return FirstBaseResource.updatePermission({ userUniqid, teamUniqid: targetUniqid, authority });
  };

  return (
    <StyledDiv>
      {firstBases.length > 0 && (
        <FirstBaseHeader firstBases={firstBases} teamIndex={teamIndex} setTeamIndex={setTeamIndex} />
      )}
      <PermissionList
        userInfo={userInfo}
        target={firstBases[teamIndex]}
        updatePermission={updatePermission}
        reload={reload}
        permissionTooltipMapping={permissionTooltipMapping}
      />
    </StyledDiv>
  );
};

export default FirstBasePermission;
